import { ShieldCheck, ShieldOff } from "lucide-react";
import { fileUrl } from "@/lib/api";
import PdfPreview from "@/components/PdfPreview";

const BASE = process.env.REACT_APP_BACKEND_URL;
const d = (s) => new Date(s).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });

export const WarrantyBadge = ({ w }) => (w.status === "valid"
  ? <span className="inline-flex items-center gap-1.5 bg-[#2E6B40] text-white px-3 py-1 text-xs tracking-wider" data-testid={`warranty-status-${w.serial}`}><ShieldCheck size={14} />WARRANTY ACTIVE</span>
  : <span className="inline-flex items-center gap-1.5 bg-[#9E2A2B] text-white px-3 py-1 text-xs tracking-wider" data-testid={`warranty-status-${w.serial}`}><ShieldOff size={14} />WARRANTY EXPIRED</span>);

export const PrintWarranty = ({ w, className = "" }) => (
  <PdfPreview path={`/warranty/${w.serial}/pdf`} filename={`warranty-${w.serial}.pdf`} label="Preview & print certificate" testid={`warranty-print-${w.serial}`} className={className} />
);

export default function WarrantyView({ w, showQr = true, canPrint = true }) {
  const rows = [["Serial No.", w.serial], ["Product", w.product_name], ...Object.entries(w.variant || {}).map(([k, v]) => [k, v]),
    ["Warranty valid from", d(w.made_date)], ["Coverage", w.types.join(", ")], ["Warranty until", w.lifetime ? "Lifetime" : d(w.expires_at)]];
  return (
    <div className="bg-white border border-[#E6DFD5] p-6 space-y-5" data-testid={`warranty-view-${w.serial}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div><p className="font-mono text-xs tracking-[0.2em] text-[#8C4F27]">AUTHENTIC CRAFTENDEMIC CERTIFICATION & WARRANTY</p><h3 className="font-serif text-2xl mt-1">{w.title}</h3></div>
        <WarrantyBadge w={w} />
      </div>
      {w.images?.length > 0 && <div className="flex gap-2 overflow-x-auto">{w.images.map((s) => <img key={s} src={fileUrl(s)} alt="" className="w-24 h-24 object-cover shrink-0" />)}</div>}
      {w.description && <p className="text-sm text-[#4a3f38] whitespace-pre-line">{w.description}</p>}
      <div className="grid sm:grid-cols-[1fr_auto] gap-6 items-end">
        <dl className="text-sm divide-y divide-[#E6DFD5]">
          {rows.map(([k, v]) => <div key={k} className="flex justify-between gap-4 py-2"><dt className="text-[#6E6259]">{k}</dt><dd className="text-right">{v}</dd></div>)}
        </dl>
        {showQr && <img src={`${BASE}/api/warranty/${w.serial}/qr.png`} alt="Warranty QR code" className="w-32 h-32 mx-auto" data-testid="warranty-qr-img" />}
      </div>
      {canPrint && <PrintWarranty w={w} />}
    </div>
  );
}
